import React, { useState } from "react";
import MetricTrendCard from "./MetricTrendCard";
import DonutAnalyticsCard from "./DonutAnalyticsCard";
import StackedBarCard from "./StackedBarCard";
import CurvedAreaCard from "./CurvedAreaCard";
import "./DashboardComponent.css";

// Mock sparkline data for trend cards
const maintenanceTrend = [{ value: 15 }, { value: 12 }, { value: 18 }, { value: 10 }, { value: 20 }, { value: 28 }, { value: 18 }, { value: 22 }, { value: 35 }, { value: 48 }];

const breakdownTrend = [{ value: 8 }, { value: 15 }, { value: 10 }, { value: 12 }, { value: 28 }, { value: 20 }, { value: 18 }, { value: 32 }, { value: 25 }, { value: 45 }];

const repairingTrend = [{ value: 82 }, { value: 88 }, { value: 80 }, { value: 85 }, { value: 92 }, { value: 86 }, { value: 95 }, { value: 89 }, { value: 98 }, { value: 94 }];

// Custom Wrench/Tools icon for Repairing card
const WrenchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#34c759" }}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

// Custom Breakdown/Warning icon
const HazardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#ff4d4f" }}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

// Custom Gear/Maintenance icon
const GearIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#3a57e8" }}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export default function DashboardComponent() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const years = Array.from({ length: 6 }, (_, index) => new Date().getFullYear() - index);
  return (
    <div className="dashboard-wrapper">
      {/* Title Header Section */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
        <div>
          <h2 className="dashboard-title">Dashboard & Reports</h2>
          <p className="dashboard-subtitle">View detailed performanance reports</p>
        </div>
        {/* <button className="export-outline-btn">Export</button>
         */}
        <div className="year-filter">
          <span className="year-filter-label">Year</span>

          <div className="year-select-wrapper">
            <select className="year-select" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>

            <span className="year-select-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>
        </div>
      </div>

      {/* Top Metrics Grid */}
      <div className="dashboard-metrics-grid">
        {/* Metric 1: Under Maintenance */}
        <MetricTrendCard
          title="Under Maintenance"
          subtitle="Units temporarily unavailable"
          value="5.20"
          trendData={maintenanceTrend}
          strokeColor="#3a57e8"
          gradientId="blueSpark"
          icon={<GearIcon />}
          iconBgColor="#e8ebf8"
        />

        {/* Metric 2: Breakdown */}
        <MetricTrendCard
          title="Breakdown"
          subtitle="System fault detected"
          value="3.18"
          trendData={breakdownTrend}
          strokeColor="#ff4d4f"
          gradientId="redSpark"
          icon={<HazardIcon />}
          iconBgColor="#ffe6e6"
        />

        {/* Metric 3: Repairing & Working */}
        <MetricTrendCard
          title="Repairing & Working"
          subtitle="System repaire is active"
          value="94.2"
          trendData={repairingTrend}
          strokeColor="#34c759"
          gradientId="greenSpark"
          icon={<WrenchIcon />}
          iconBgColor="#e6fbe6"
        />

        {/* Metric 4: Donut Chart & Legends */}
        <DonutAnalyticsCard />
      </div>

      {/* Bottom Main Charts Grid */}
      <div className="dashboard-charts-grid mt-4">
        {/* Stacked Bar Chart */}
        <StackedBarCard />

        {/* Curved Area Chart */}
        <CurvedAreaCard />
      </div>
    </div>
  );
}
